














































import DialogoDeEdicaoDeRegraDeInadimplencia from '@/components/titulos/DialogoDeEdicaoDeRegraDeInadimplencia.vue'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import { RegraDeInadimplencia } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindRegraDeInadimplenciaUseCase } from '@/usecases/titulos/FindRegraDeInadimplenciaUseCase'
import axios, { CancelTokenSource } from 'axios'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Ref, Watch } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'

@Component({
	components: {
		DialogoDeEdicaoDeRegraDeInadimplencia,
		DataTableDeCrud,
	},
})
export default class TelaDeCadastroDeRegrasDeInadimplencia extends Vue {
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDeRegraDeInadimplencia

	regras: RegraDeInadimplencia[] = []
	regra: RegraDeInadimplencia | null = null
	totalRegistros = -1
	carregando = false
	mostrar = false
	busca = ''
	editando = true
	cancelToken: CancelTokenSource | null = null
	mostrarDialogoDeEdicao = false

	findRegraDeInadimplenciaUseCase = new FindRegraDeInadimplenciaUseCase()

	headers = [
		{ text: 'Nome', value: 'nome' },
		{ text: 'Status', value: 'ativa' },
		{ text: 'Dias', value: 'dias' },
	]

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	created() {
		this.buscar()
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()

			const params = {
				page: this.paginacao.page - 1,
				busca: this.busca || undefined,
				size: this.paginacao.itemsPerPage,
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.findRegraDeInadimplenciaUseCase.findPageRegrasDeInadimplencia(params, axiosConfig)
			this.totalRegistros = page.totalElements
			this.regras = page.content
			this.carregando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.carregando = false
		}
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.buscar

	@Watch('busca')
	onChangeBusca() {
		this.paginacao.page = 1
		this.buscar()
	}

	atualizarRegraDeInadimplencia(regraDeInadimplencia: RegraDeInadimplencia) {
		const index = this.regras.findIndex(p => p.id === regraDeInadimplencia.id)
		if (index !== -1) {
			this.regras.splice(index, 1, regraDeInadimplencia)
		}
	}

	abrirDialogoDeCriarRegraDeInadimplencia() {
		this.editando = false
		const regraDeInadimplencia = criarRegraDeInadimplencia()
		this.dialogoDeEdicao.mostrar(regraDeInadimplencia, true)
	}

	abrirDialogoDeRegraDeInadimplencia(indice: any) {
		this.regra = this.regras[indice]
		this.editando = true
		this.dialogoDeEdicao.mostrar(this.regra, false)
	}

	obterDiasDeVencimento(regra: RegraDeInadimplencia): string {
		if (!regra.condicaoDaRegraDeInadimplencias || !regra.condicaoDaRegraDeInadimplencias.length) {
			return '-'
		}

		const condicao = regra.condicaoDaRegraDeInadimplencias.find(c => c.tipoDeGatilho === 'Dias de vencimento')

		return condicao ? condicao.valor : '-'
	}

	incluirRegraNova(regra: RegraDeInadimplencia) {
		this.regras.unshift(regra)
		this.totalRegistros = (this.totalRegistros ?? 0) + 1
	}
}

export function criarRegraDeInadimplencia () {
	const regraDeInadimplencia: RegraDeInadimplencia = {
		id: '',
		nome: '',
		ativa: false,
		condicaoDaRegraDeInadimplencias: [],
		gruposEconomicos: [],
		formasDePagamento: [],
	}
	return regraDeInadimplencia
}
